const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/settings/inbox/moderation/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { MODERATION_TABS, STATUS_OPTIONS_MAP, TAB_QUERY_NAME } from "@circle-react/components/SettingsApp/Moderation/constants";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const moderationSearchSchema = z.object({
  [TAB_QUERY_NAME]: z.enum(MODERATION_TABS as [FlaggedContentStatus, ...FlaggedContentStatus[]]).optional().catch(STATUS_OPTIONS_MAP.INBOX)
});
export const Route = createFileRoute("/_protected/settings/inbox/moderation")({
  validateSearch: moderationSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});